import { invariant } from './invariant';
import { isAxiosError } from './httpError';
import type { AdditionalParams, ApiCallResult, ApiClient } from './apiClient';

/*
  The functions below allow injecting the HTTP API call mechanism. They are used as a
  convenience to make migrating the code of the existing HTTP API facade
  accessing global state to a facade that allows for dependency injection
  easier and less invasive.
 */

export function apiGet(client: ApiClient, path: string, additionalParams: AdditionalParams = {}): Promise<ApiCallResult> {
  return client.call(client.config(), path, 'GET', additionalParams);
}

export function apiPut(client: ApiClient, path: string, body: any = {}, additionalParams: AdditionalParams = {}): Promise<ApiCallResult> {
  return client.call(client.config(), path, 'PUT', additionalParams, body);
}

export function apiPost(client: ApiClient, path: string, body: any = {}, additionalParams: AdditionalParams = {}): Promise<ApiCallResult> {
  return client.call(client.config(), path, 'POST', additionalParams, body);
}

export function apiPatch(client: ApiClient, path: string, body: any = {}, additionalParams: AdditionalParams = {}): Promise<ApiCallResult> {
  return client.call(client.config(), path, 'PATCH', additionalParams, body);
}

export async function apiDelete(client: ApiClient, path: string, body: any = {}, additionalParams: AdditionalParams = {}): Promise<ApiCallResult> {
  try {
    return await client.call(client.config(), path, 'DELETE', additionalParams, body);
  } catch (err) {
    if (!isAxiosError(err) || err.code != '404') {
      throw err;
    }

    /*
      HTTP DELETE is idempotent, but servers are permitted to return code 404
      resource has previously been deleted. Therefore, do not consider code
      404 as an error during a delete operation.
    */
    invariant(err.response, '404 must come from response');
    return err.response;
  }
}
